import PostDeviationSelector from './PostDeviationSelector.connected';
export default PostDeviationSelector;
//# sourceMappingURL=index.js.map